// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:27:09

export default {
  "id": "pet-runner",
  "slug": "pet-runner",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d74ac3341c7a4aafb9589555e277d8d7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d74ac3341c7a4aafb9589555e277d8d7/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Pet Runner",
      "description": "Pet Runner is a fast-paced platformer where your pet runs forward automatically, and you must jump, dodge obstacles, defeat enemies, and collect coins. Play in Endless Mode for infinite fun or tackle unique challenges in Level Mode. Use up to three lives, hit checkpoints, and complete daily challenges to earn coins. Unlock and customize adorable pets in the shop to enhance your adventure. With its exciting gameplay and charming rewards, Pet Runner offers fun for all ages!",
      "instructions": "On Desktop: Press \"Arrow Up\" to Jump, Press and Hold \"Arrow Down\" to Crouch\nOn Mobile: Swipe Up to Jump, Swipe Down and Hold to Crouch",
      "genres": [
        "Adventure",
        "Agility"
      ],
      "tags": [
        "dinosaurs",
        "pet",
        "pixel",
        "platformer",
        "run"
      ]
    },
    "zh-CN": {
      "title": "宠物跑步者",
      "description": "宠物跑酷是一款快节奏的平台游戏，你的宠物会自动向前跑，你必须跳跃、躲避障碍、击败敌人并收集金币。在无尽模式中享受无限乐趣，或在关卡模式中挑战独特任务。使用最多三个生命值，通过检查点，完成每日挑战以赚取金币。在商店解锁并定制可爱的宠物来增强你的冒险。凭借其激动人心的游戏玩法和迷人的奖励，宠物跑酷为所有年龄段的人提供乐趣！",
      "instructions": "在电脑上：按“上箭头”键跳跃，按住“下箭头”键蹲下\n在手机上：向上滑动跳跃，向下滑动并按住蹲下",
      "genres": [
        "冒险",
        "敏捷"
      ],
      "tags": [
        "恐龙",
        "宠物",
        "像素",
        "平台游戏",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "寵物跑者",
      "description": "Pet Runner 是一款快节奏的平台遊戲，您的寵物會自動向前奔跑，您必須跳躍、躲避障礙、擊敗敵人並收集硬幣。在無盡模式中享受無窮的樂趣，或在等級模式中挑戰獨特的挑戰。使用最多三條生命，通過檢查點並完成每日挑戰來獲得硬幣。在商店中解鎖並定制可愛的寵物來增強您的冒險。Pet Runner 精彩的遊戲玩法和迷人的獎勵，為所有年齡層提供樂趣！",
      "instructions": "在桌面版：按“上箭頭”跳躍，按住“下箭頭”蹲下\n在移動版：向上滑動跳躍，向下滑動並按住蹲下",
      "genres": [
        "冒險",
        "靈敏度"
      ],
      "tags": [
        "恐龍",
        "寵物",
        "像素",
        "平台遊戲",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "寵物跑者",
      "description": "Pet Runner是一款快节奏的平台遊戲，你的寵物會自動向前奔跑，你必須跳躍、躲避障礙、擊敗敵人並收集硬幣。在無限模式中享受無盡的樂趣或在等級模式中挑戰獨特的挑戰。使用最多三條生命，擊破檢查點並完成每日挑戰以贏取硬幣。在商店中解鎖及定製可愛的寵物來提升你的冒險。Pet Runner擁有刺激的遊戲玩法和迷人的獎勵，適合所有年齡層享受！",
      "instructions": "在桌面版：按「上箭頭」跳躍，按住並保持「下箭頭」蹲下\n在移動版：向上滑動跳躍，向下滑動並保持蹲下",
      "genres": [
        "冒險",
        "靈巧"
      ],
      "tags": [
        "恐龍",
        "寵物",
        "像素",
        "平台遊戲",
        "奔跑"
      ]
    },
    "ja": {
      "title": "ペットランナー",
      "description": "ペットランナーは、ペットが自動的に前に走る高速プラットフォームゲームで、ジャンプし、障害物を避け、敵を倒し、コインを集める必要があります。エンドレスモードで無限の楽しみを楽しんだり、レベルモードでユニークな挑戦に挑戦してください。最大3回のライフを使い、チェックポイントに到着し、日次の挑戦を完了してコインを稼ぎましょう。ショップで魅力的なペットをアンロックし、カスタマイズして冒険を強化してください。楽しいゲームプレイと魅力的な報酬で、全世代に楽しんでもらえるペットランナーです！",
      "instructions": "デスクトップ版：ジャンプするには「上矢印」を押す、しゃがむには「下矢印」を押しながら保持\nモバイル版：ジャンプするには上にスワイプ、しゃがむには下にスワイプしながら保持",
      "genres": [
        "アドベンチャー",
        "アギリティ"
      ],
      "tags": [
        "恐竜",
        "ペット",
        "ピクセル",
        "プラットフォーム",
        "走る"
      ]
    },
    "ko": {
      "title": "펫 러너",
      "description": "Pet Runner는 자동으로 앞으로 달리는 반려동물을 통해 점프하고 장애물을 피하며 적을 물리치고 동전을 모으는 빠른 플랫폼 게임입니다. Endless Mode에서 무한한 재미를 즐기거나 Level Mode에서 독특한 도전을 맞추세요. 세 가지 생명을 사용하여 체크포인트를 통해 하루의 도전을 완료하여 동전을 얻습니다. 샵에서 귀염둥이 반려동물을 해금하고 개성화하여 모험을 더욱 풍요롭게하세요. 흥미진진한 게임플레이와 매력적인 보상으로 모든 연령대에게 즐거움을 제공합니다!",
      "instructions": "데스크톱: \"화면 위 방향키\"를 눌러 점프하세요, \"화면 아래 방향키\"를 누른 상태로 유지하여 숨을 수 있습니다.\n모바일: 위쪽으로 스크롤하여 점프하세요, 아래쪽으로 스크롤하고 유지하여 숨을 수 있습니다.",
      "genres": [
        "모험",
        "기민함"
      ],
      "tags": [
        "공룡",
        "반려동물",
        "픽셀",
        "플랫폼게임",
        "달리기"
      ]
    },
    "fr": {
      "title": "Pet Runner",
      "description": "Pet Runner est un plate-formiste rapide où votre animal de compagnie coure automatiquement en avant, et vous devez sauter, éviter les obstacles, vaincre les ennemis et collecter des pièces. Jouez en mode Infini pour du plaisir sans fin ou affrontez des défis uniques en mode Niveau. Utilisez jusqu'à trois vies, atteignez des points de contrôle et accomplissez des défis quotidiens pour gagner des pièces. Débloquez et customisez des animaux de compagnie adorables dans la boutique pour améliorer votre aventure. Avec son gameplay passionnant et ses récompenses charmeuses, Pet Runner offre du divertissement pour tous les âges !",
      "instructions": "Sur ordinateur : Appuyez sur \"Flèche Haut\" pour sauter, appuyez et tenez \"Flèche Bas\" pour se baisser\nSur mobile : Faites glisser vers le haut pour sauter, faites glisser vers le bas et tenez pour se baisser",
      "genres": [
        "Aventure",
        "Agilité"
      ],
      "tags": [
        "dinosaur",
        "animal de compagnie",
        "pixel",
        "plate-forme",
        "course"
      ]
    }
  }
};
